const LargeChevronRight = ({fillColor = '#212124', width = 20, height = 20}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <path
      fill={fillColor}
      d="m14.193 10.442-6.25 6.25a.626.626 0 0 1-.885-.884L12.867 10 7.058 4.192a.625.625 0 1 1 .885-.884l6.25 6.25a.626.626 0 0 1 0 .884Z"
    />
  </svg>
);
export default LargeChevronRight;
